module.exports = __webpack_public_path__ + "assets/media/quote-icon.805f7a22.svg";